/** A selectable time option with matching value and label in 'HH:mm' form. */

/** Quarter-hour time options ('HH:mm') spanning a full day for the time dropdown. */
export var TIME_OPTIONS = Array.from({
  length: 96
}, function (_, index) {
  var hours = String(Math.floor(index / 4)).padStart(2, "0");
  var minutes = String(index % 4 * 15).padStart(2, "0");
  var time = "".concat(hours, ":").concat(minutes);
  return {
    value: time,
    label: time
  };
});

/** Formats a Date's local time as 'HH:mm', or '' when null. */
export function formatTimeLabel(date) {
  if (!date) return "";
  var hours = String(date.getHours()).padStart(2, "0");
  var minutes = String(date.getMinutes()).padStart(2, "0");
  return "".concat(hours, ":").concat(minutes);
}

/** Returns true when the value is a valid 24-hour 'HH:mm' time string. */
export function isValidTimeLabel(value) {
  return /^([01]\d|2[0-3]):[0-5]\d$/.test(value.trim());
}